import * as React from 'react';
import { Alert } from 'react-bootstrap'
import { I18NString, Component } from "../Utils";

interface SidebarItem {
    id: string;
    title: I18NString;
    percent:number;
}

interface Props {
    items: Array<SidebarItem>;
    onSelected: (id:string) =>void;
    isClose: boolean;
    value?:string;
    status: number;
}

interface PercentProps{
    percent:number;
}

const Percent =({percent}:PercentProps) =>{
    if(percent > 0 && percent <= 45)
        return (<span className="label label-danger pull-right">{`${percent}%`}</span>)
    else if(percent > 45 && percent < 100)
        return (<span className="label label-warning pull-right">{`${percent}%`}</span>)
    else if(percent >= 100)
        return (<span className="label label-success  pull-right">{`${percent}%`}</span>)

    return <span></span>
}


class Sidebar extends Component<Props,{}>{

    onClick(e: React.MouseEvent<HTMLAnchorElement>, id: string){
        e.stopPropagation();
        e.preventDefault();
        this.props.onSelected(id);
        document.getElementsByClassName("reportbox-content-viewport")[0].scrollTo(0,0);
    }

    createItemMenu(el: SidebarItem, idx: number){
            return (
                <li key={idx} className={ this.props.value === el.id ? 'active' : '' } >
                    <a onClick={e =>this.onClick(e, el.id) } >
                        <span className="nav-pills-label">
                            { el.id === 'ReadyPDF' && (<span className="fa fa-file-pdf-o"></span>) }
                            {this.tr(el.title)}
                        </span>
                        <Percent percent={el.percent}/>
                    </a>
                </li>
            )
    }

    render() {
        return (
            <ul className="nav nav-pills nav-stacked">
                {this.props.items.map((el, idx) => this.createItemMenu(el, idx))}
                {this.props.isClose && (
                    <li>
                      <Alert bsStyle="danger">
                        <strong>Версия заявки устарела</strong><br/>
                        Ваша версия Черновика данной заявки устарела. Необходимо создать новую заявку по данной программе, не копируя текущую.
                      </Alert>
                    </li>
                )}
            </ul>
        )
    }
}

export default Sidebar
